import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '@services/app.service';
import { Observable } from 'rxjs';
const BASE_CLASSES = 'main-sidebar elevation-4';

@Component({
  selector: 'app-admin-menu-sidebar',
  templateUrl: './admin-menu-sidebar.component.html',
  styleUrl: './admin-menu-sidebar.component.scss'
})
export class AdminMenuSidebarComponent {
  @HostBinding('class') classes: string = BASE_CLASSES;
  public ui: Observable<UiState>;
  public user;
  public menu = MENU;

  constructor(
    public appService: AppService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    this.ui = this.store.select('ui');
    this.ui.subscribe((state: UiState) => {
      this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
    });
  }
}

export const MENU = [
  {
    name: 'Dashboard',
    iconClasses: 'fas fa-tachometer-alt',
    path: ['/admin-dashboard']
  },

];

